// export const baseURL= 'http://localhost/projects/sddm/public/api/web/';
// export const baseURL= 'http://192.168.10.15/projects/sddm/public/api/web/';
export const baseURL= 'https://api.sddmads.in/api/web/';
// export const baseURL= 'https://sddmads.in/webservice/public/api/web/';